import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const STATUS_META = {
  ok: { icon: "\u2705", cls: "ok" },
  warn: { icon: "\u26A0\uFE0F", cls: "warn" },
  fail: { icon: "\u274C", cls: "fail" },
  pending: { icon: "\u23F3", cls: "pending" },
};

const fmtDateTime = (iso) => {
  try {
    return new Date(iso).toLocaleString("ar", {
      day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso || "";
  }
};

export default function ReadinessCard() {
  const [data, setData] = useState(null);

  const fetchReadiness = useCallback(async () => {
    try {
      const res = await api.get("/monitor/readiness", { timeout: 20000 });
      setData(res.data);
    } catch (e) {
      if (e?.response?.status !== 401) console.error("readiness fetch error", e);
    }
  }, []);

  useEffect(() => {
    fetchReadiness();
    const t = setInterval(fetchReadiness, 60000);
    return () => clearInterval(t);
  }, [fetchReadiness]);

  if (!data) {
    return (
      <section className="card readiness-card" data-testid="readiness-card">
        <div className="card-head"><h2>🎯 جاهزية اعتماد Ookla</h2></div>
        <div className="monitor-loading" data-testid="readiness-loading">
          <span className="spinner big" /> جاري تجميع حالة الجاهزية...
        </div>
      </section>
    );
  }

  const pct = Math.round((data.done / data.total) * 100);

  return (
    <section className="card readiness-card" data-testid="readiness-card">
      <div className="card-head">
        <h2>🎯 جاهزية اعتماد Ookla</h2>
        <span className="readiness-score" data-testid="readiness-score">
          {data.done} / {data.total} مكتمل
        </span>
      </div>

      {data.all_ready ? (
        <div className="submission-banner success" data-testid="readiness-all-ready">
          🎉 <b>سيرفرك ظاهر رسمياً في قوائم Speedtest!</b> اكتملت كل شروط الاعتماد
        </div>
      ) : (
        <div className="readiness-progress" data-testid="readiness-progress">
          <div className="readiness-bar">
            <div className="readiness-bar-fill" style={{ width: `${pct}%` }} />
          </div>
          <span className="readiness-pct">{pct}%</span>
        </div>
      )}

      <div className="readiness-list" data-testid="readiness-list">
        {data.items.map((item) => {
          const meta = STATUS_META[item.status] || STATUS_META.pending;
          return (
            <div key={item.id} className={`readiness-item ${meta.cls}`} data-testid={`readiness-item-${item.id}`}>
              <span className="readiness-icon">{meta.icon}</span>
              <div className="readiness-text">
                <span className="readiness-label">{item.label}</span>
                <span className="readiness-detail" data-testid={`readiness-detail-${item.id}`}>{item.detail}</span>
              </div>
              {item.last_checked && (
                <span className="readiness-time" dir="ltr">{fmtDateTime(item.last_checked)}</span>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
